// extracted by mini-css-extract-plugin
export var acceptButton = "_16-6";
export var backdropBlur = "_16-0";
export var fullContent = "_16-5";
export var link = "_16-7";
export var linkIcon = "_16-8";
export var sideContent = "_16-4";
export var sideImage = "_16-3";
export var sideImageWrapper = "_16-2";
export var splitLayout = "_16-1";